import React, { SVGProps } from 'react';

export default ({ ...props }: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 177 33" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M20.9992 -0.0010376L21 0H0C12.1734 0 23.2883 4.53164 31.7499 12H32.1135C46.8339 25.0629 66.2366 33 87.5 33C108.763 33 128.166 25.0629 142.886 12H177V11.9998H143C152.061 4.53156 163.964 0 177 0H154C154 -0.000345864 154.001 -0.00069173 154.001 -0.0010376H20.9992Z" />
  </svg>
);
